import { TranslocoService } from '@jsverse/transloco';
import { map, Observable, take } from 'rxjs';

export function translocoInitializer(translocoService: TranslocoService): () => Observable<boolean> {
	return () =>
		translocoService.selectTranslation().pipe(
			take(1),
			map((_) => true)
		);
}
